import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { UrlService } from '../../../../environments/urlService';
import { AiHistoryParamType, GlobalAiDebugInfoDto, GlobalAiRequestDto } from '../utils';
import { AbstractAiBackendService } from '../../ai/abstract-ai-backend.service';
import { Observable } from 'rxjs';
import { IS_SPINNER_ACTIVE } from 'src/app/util/interceptors';

@Injectable({
  providedIn: 'root',
})
export class GlobalAiBackendService extends AbstractAiBackendService {

  constructor(http: HttpClient, urlService: UrlService) {
    super(http, urlService, 'global-ai');
  }

  protected buildHistoryParams(orgId: number): AiHistoryParamType {
    return { orgId };
  }

  /**
   * Fetches the debug information for a specific AI request
   * including the raw data and system prompt used for generation.
   */
  getDebugInfo(request: GlobalAiRequestDto): Observable<GlobalAiDebugInfoDto> {
    return this.http.post<GlobalAiDebugInfoDto>(`${this.url}/debug-info`, request, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }
}
